import React from "react";
import PropTypes from "prop-types";
import { Autocomplete } from "@material-ui/lab";
import { InputAdornment, IconButton } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { v4 } from "uuid";
import { CustomTextField } from "./styles";
import { secondary } from "../../../assets/variables.module.scss";

export default function SearchableFilter({
  placeholder,
  options,
  onChange,
  ...rest
}) {
  return (
    <Autocomplete
      options={options}
      getOptionLabel={({ name }) => name}
      onChange={(e, value) => onChange(value?.id)}
      renderInput={(params) => {
        return (
          <CustomTextField
            {...params}
            variant="outlined"
            size="small"
            placeholder={placeholder}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment>
                  {params.InputProps.endAdornment.props.children.map(
                    (child, i) =>
                      i === 0 ? (
                        child
                      ) : (
                        <IconButton
                          key={v4()}
                          className="iconButton"
                          disableTouchRipple
                          onClick={
                            params.InputProps.endAdornment.props.children[1]
                              .props.onClick
                          }
                        >
                          {params.InputProps.endAdornment.props.children[1]
                            .props["aria-label"] === "Close" ? (
                            <KeyboardArrowUp
                              key={v4()}
                              size={20}
                              color={secondary}
                            />
                          ) : (
                            <KeyboardArrowDown
                              key={v4()}
                              size={20}
                              color={secondary}
                            />
                          )}
                        </IconButton>
                      )
                  )}
                </InputAdornment>
              ),
            }}
          />
        );
      }}
      {...rest}
    />
  );
}

SearchableFilter.defaultProps = {
  placeholder: "",
  options: [],
  onChange: () => {},
};

SearchableFilter.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
};
